import { Alert } from "@mui/material";
import { useTranslation } from "react-i18next";

export const ErrorFallback = () => {
  const { t } = useTranslation();
  return <Alert sx={{m: 2}} severity="error">{t("gridBot.chart.error")}</Alert>;
};

export default ErrorFallback;
